export default {
  CURRENT: 'current',
  ERROR: 'error',
  SUCCESS: 'success',
  EMPTY: 'empty'
}
